import { Component, ChangeDetectionStrategy } from '@angular/core';
import { getFileIcon } from '../cloud-document-file-icon.util';
import { CloudDocumentService } from '../cloud-document.service';

@Component({
    selector: 'app-cloud-document-file-grid',
    templateUrl: './cloud-document-file-grid.component.html',
    styleUrls: ['./../cloud-document.modal.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CloudDocumentFileGridComponent {
  getFileIcon = getFileIcon;

  constructor(private cloudDocumentService: CloudDocumentService) {}

  get items()        { return this.cloudDocumentService.getFoldersForGrid(); }
  get isExportMode() { return this.cloudDocumentService.isExportMode; }

  isFileSelected(id: string) { return this.cloudDocumentService.isFileSelected(id); }

  onItemClick(item: any) {
    if (item.isFolder) {
      if (this.cloudDocumentService.isSearchActive) {
        this.cloudDocumentService.navigateToSearchResult(item);
      } else {
        this.cloudDocumentService.showFolders(item.parent, item.id, item.name);
        if (this.cloudDocumentService.isExportMode) this.cloudDocumentService.listenToFolderSelection();
      }
    } else if (!this.cloudDocumentService.isExportMode) {
      this.cloudDocumentService.toggleCheckbox(item.id, item.name, item.parent);
    }
  }

  onCheckboxChange(event: any, item: any) {
    this.cloudDocumentService.onFileCheckItem(event, item.id, item.name, item.parent);
  }
}
